import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row, Card } from 'reactstrap';
import { useRouter } from "next/router";
import useSectors from '@/hooks/useSectors';
import styles from './styles.module.scss';
import Link from "next/link";

export const Sectors = ({
    className,
    title,
    heading,
    titleColour,
    content
}) => {

    const { asPath } = useRouter();
    const locale = asPath === "/us" || asPath.startsWith("/us/") ? "/us/" : "/";

    const items = useSectors({locale});

    if (!items || !items.length > 0) {
        return null;
    }
    
    return (
        <section className={`${styles.root} ${className}`}>
            <Container className="py-4 py-md-5">
                <div className="mb-5 text-center">
                    {title &&
                        <h2
                            className={`text-${titleColour?.variant} ${heading}`}
                            style={titleColour?.custom ? { color: titleColour?.custom } : null}
                        >
                            {title}
                        </h2>
                    }
                    {content &&
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                    }
                </div>
                <Row className="wrapper flex-wrap text-center">
                    {items.map((item, index) => (
                        <Card key={index} className="bg-transparent border-0">
                            <div className="mb-4 overflow-hidden rounded-4">
                                <Link href={`${locale}${locale == "/us/" ? "markets" : "specialisms"}/${item.url_slug}`}>
                                    <a>
                                        <SourceFlowImage
                                            src={item.image ? item.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                            size="800x500"
                                            alt={item?.title}
                                            className="card-img"
                                        />
                                    </a>
                                </Link>
                            </div>
                            <Link href={`${locale}${locale == "/us/" ? "markets" : "specialisms"}/${item.url_slug}`}>
                                <a>
                                    <p className="fs-5"><strong>{item?.title}</strong></p>
                                </a>
                            </Link>
                        </Card>
                    ))}
                </Row>
            </Container>
        </section>
    )
}

export default Sectors;
